import * as core from '../../../../../../../core'
import * as anomaly from '../anomaly'

export const RESOURCE = {
  payload: {
    description: 'Room does not exist',
    enumId: core.dms.models.Enum.Id.from({
      partialId: anomaly.RESOURCE.payload.partialId,
    }),
    id: 'ROOM_DOES_NOT_EXISTS',
    name: 'Room does not exist',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
